<template>
  <router-view />
</template>

<script>

export default {
  name: 'OrganizationSettingsLanding',
};
</script>
